import axios from "axios";
import * as ApiSettingService from "../../db/serviceApiSetting";
import { env } from "../../config/env";

/**
 * Send a request to scan a barcode for prepacking
 * @param code - an optional number, 1 for handle input locator code
 * @param locator - an optional string, the locator code
 * @param sku - an optional string, the sku of the product
 * @returns a Promise that resolves to the response from the server
 */
export const scanBarcode = async (
  code?: number,
  locator?: string,
  sku?: string
) => {
  const accountAccess = await ApiSettingService.getAccess();
  if (!accountAccess) {
    console.error("Failed To Get Access Token");
    return {
      statusCode: 401,
      error: {
        code: "ACCESS_TOKEN_ERROR",
        message: "Failed to get access token",
      },
    };
  }

  const token = accountAccess?.accessToken;

  const url = `${env.SERVER_URL}/prepacks/scanBarcode`;

  const requestBody = {
    code,
    locator,
    sku,
  };

  try {
    const response = await axios.post(url, requestBody, {
      headers: {
        // Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (response && response?.status !== 200) {
      return {
        statusCode: response.status,
        error: {
          code: "SERVER_ERROR",
          message: response.data.message || "An error occurred",
        },
      };
    }

    return {
      statusCode: 200,
      message: response.data.message,
      data: response.data,
    };
  } catch (error: any) {
    if (error?.response && error?.response?.status === 400) {
      console.error(
        "Error sending request for scan barcode",
        error?.response?.data
      );
      return {
        statusCode: 400,
        error: {
          code: error?.response?.data?.code || "BAD_REQUEST",
          message: error?.response?.data?.message || "Bad request",
        },
      };
    }

    return {
      statusCode: 500,
      error: {
        code: error?.code || "SERVER_ERROR",
        message: error?.message || "An unexpected error occurred",
      },
    };
  }
};

export const reForwardOrderInCancel = async (orderId: string) => {
  const accountAccess = await ApiSettingService.getAccess();
  if (!accountAccess) {
    console.error("Failed To Get Access Token");
    return {
      statusCode: 401,
      error: {
        code: "ACCESS_TOKEN_ERROR",
        message: "Failed to get access token",
      },
    };
  }

  const token = accountAccess?.accessToken;

  const url = `${env.SERVER_URL}/playground/bulkParseReForwardVP`;

  const requestBody = [orderId];

  try {
    const response = await axios.post(url, requestBody, {
      headers: {
        // Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (response && response?.status !== 200) {
      return {
        statusCode: response.status,
        error: {
          code: "SERVER_ERROR",
          message: response.data.message || "An error occurred",
        },
      };
    }

    return {
      statusCode: 200,
      message: response.data.message,
      data: response.data,
    };
  } catch (error: any) {
    if (error?.response && error?.response?.status === 400) {
      console.error(
        "Error sending request for reForwardOrder",
        error?.response?.data
      );
      return {
        statusCode: 400,
        error: {
          code: error?.response?.data?.code || "BAD_REQUEST",
          message: error?.response?.data?.message || "Bad request",
        },
      };
    }

    return {
      statusCode: 500,
      error: {
        code: error?.code || "SERVER_ERROR",
        message: error?.message || "An unexpected error occurred",
      },
    };
  }
};

export const reForwardOrder = async (orderId: string) => {
  const accountAccess = await ApiSettingService.getAccess();
  if (!accountAccess) {
    console.error("Failed To Get Access Token");
    return {
      statusCode: 401,
      error: {
        code: "ACCESS_TOKEN_ERROR",
        message: "Failed to get access token",
      },
    };
  }

  const token = accountAccess?.accessToken;

  const url = `${env.SERVER_URL}/playground/bulkParseVPForward`;

  const requestBody = [orderId];

  try {
    const response = await axios.post(url, requestBody, {
      headers: {
        // Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (response && response?.status !== 200) {
      return {
        statusCode: response.status,
        error: {
          code: "SERVER_ERROR",
          message: response.data.message || "An error occurred",
        },
      };
    }

    return {
      statusCode: 200,
      message: response.data.message,
      data: response.data,
    };
  } catch (error: any) {
    if (error?.response && error?.response?.status === 400) {
      console.error(
        "Error sending request for reForwardOrder",
        error?.response?.data
      );
      return {
        statusCode: 400,
        error: {
          code: error?.response?.data?.code || "BAD_REQUEST",
          message: error?.response?.data?.message || "Bad request",
        },
      };
    }

    return {
      statusCode: 500,
      error: {
        code: error?.code || "SERVER_ERROR",
        message: error?.message || "An unexpected error occurred",
      },
    };
  }
};
